export default "__VITE_ASSET__CdiE1vR4__"